import React, { Component, createRef } from 'react';

// CSS
import '../Subscriptions/Subscription.scss';
import '../Courses/Courses.scss';

// Helper
import { checkCookie } from '../../Helper/Cookies';
import { apiFetch, uploadCourseMedia } from '../../Helper/Api';

// Components
import Header from '../../components/Header/Header';
import { PageLoading, Alert } from '../../components/UI/Feedback';
import { Card } from 'primereact/card';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { FileUpload } from 'primereact/fileupload';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Toast } from 'primereact/toast';
import { Button } from 'primereact/button';

// Properties
const properties = require('../../properties.json');

class ShareMeta extends Component {
    constructor(props) {
        super(props);
        this.toast = createRef(null);
    }

    state = {
        ogTitle: '',
        ogDescription: '',
        ogImageUrl: '',
        name: '',
        description: '',
        image: '',
        // read from the same /teachers/me call, only so the preview can show
        // the address the link will actually carry
        customDomain: '',
        saving: false,
        uploading: false,
        loading: true,
    }

    componentDidMount() {
        document.title = properties.site_name + " | مشاركة الرابط";
        if (!checkCookie('name')) {
            window.localStorage.removeItem('currentTeacher');
            window.location.href = `/`;
            return;
        }
        apiFetch("/teachers/me")
            .then(me => {
                this.setState({
                    ogTitle: me.ogTitle || '',
                    ogDescription: me.ogDescription || '',
                    ogImageUrl: me.ogImageUrl || '',
                    name: me.name || '',
                    description: me.description || '',
                    image: me.image || '',
                    customDomain: me.customDomain || '',
                    loading: false,
                });
            })
            .catch(error => {
                this.setState({ loading: false });
                console.error('Error:', error);
            });
    }

    uploadShareImage = async (event) => {
        const file = event.files && event.files[0];
        if (!file) return;
        this.setState({ uploading: true });
        try {
            const url = await uploadCourseMedia(file);
            this.setState({ ogImageUrl: url, uploading: false });
            this.toast.current.show({ severity: 'info', summary: 'تم بنجاح', detail: 'تم رفع الصورة' });
        } catch (error) {
            console.error('Error:', error);
            this.setState({ uploading: false });
            this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'فشل رفع الصورة' });
        } finally {
            event.options && event.options.clear && event.options.clear();
        }
    }

    save = () => {
        const { ogTitle, ogDescription, ogImageUrl } = this.state;
        this.setState({ saving: true });
        apiFetch("/teachers/me/share-meta", { method: "PUT", body: { ogTitle, ogDescription, ogImageUrl } })
            .then(() => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'success', summary: 'تم بنجاح', detail: 'تم حفظ بيانات المشاركة' });
            })
            .catch(error => {
                this.setState({ saving: false });
                this.toast.current.show({ severity: 'error', summary: 'لم تتم العملية', detail: error.message || 'خطأ في الإتصال' });
            });
    }

    render() {
        const { ogTitle, ogDescription, ogImageUrl, name, description, image, customDomain, saving, uploading, loading } = this.state;

        // Every field here falls back to the account's own, which is what the
        // page has always said in prose. The preview resolves that fallback so
        // the teacher sees the result rather than the rule.
        const shownTitle = ogTitle || name || 'إسم حسابك';
        const shownDesc = ogDescription || description || 'وصف حسابك هيظهر هنا';
        const shownImage = ogImageUrl || image || '';
        const shownHost = customDomain || properties.site_name || 'موقعك';

        return (
            <>
                {/* the save rides the page's own title strip, so it is in
                    sight from the first frame rather than at the end of a scroll */}
                <Header
                    pageName="مشاركة الرابط"
                    action={{
                        label: saving ? "جاري الحفظ..." : "حفظ",
                        icon: saving ? "pi pi-spin pi-spinner" : "pi pi-check",
                        disabled: saving,
                        onClick: this.save,
                    }}
                />
                <Toast ref={this.toast}></Toast>
                <div className="content">
                    <div className="container">
                        <div className="card">
                            <Card>
                                {/* the page keeps its shape while the first
                                    request is out, instead of rendering nothing */}
                                <PageLoading busy={loading}>
                                    <Alert kind="info" title="دي بتظهر فين؟">
                                        لما حد يبعت رابط موقعك على <b>واتساب</b> أو <b>فيسبوك</b> أو أي مكان تاني.
                                        سيب أي خانة فاضية لو عايز تستخدم بيانات حسابك العادية.
                                    </Alert>

                                    <section className="ui-sec" style={{ "--d": "0ms" }}>
                                        <h3>
                                            <span className="n">١</span>
                                            <span className="t">
                                                العنوان والوصف
                                                <small>النص اللي بيظهر جنب الصورة في المعاينة</small>
                                            </span>
                                        </h3>

                                        <div className="p-grid p-fluid">
                                            <div className="p-col-12 p-md-12">
                                                <div className="p-inputgroup">
                                                    <span className="p-float-label">
                                                        <InputText
                                                            id="og-title"
                                                            value={ogTitle}
                                                            placeholder={name || 'إسم حسابك'}
                                                            onChange={(e) => this.setState({ ogTitle: e.target.value })}
                                                        />
                                                        <label htmlFor="og-title">
                                                            عنوان المشاركة
                                                            <small className="ui-fieldhint">اختياري — سيبه فاضي ويستخدم إسم حسابك</small>
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>

                                            <div className="p-col-12 p-md-12">
                                                <div className="p-inputgroup">
                                                    <span className="p-float-label">
                                                        <InputTextarea
                                                            id="og-desc"
                                                            rows={3}
                                                            autoResize
                                                            value={ogDescription}
                                                            placeholder={description || 'وصف حسابك'}
                                                            onChange={(e) => this.setState({ ogDescription: e.target.value })}
                                                        />
                                                        <label htmlFor="og-desc">
                                                            وصف المشاركة
                                                            <small className="ui-fieldhint">اختياري — سيبه فاضي ويستخدم وصف حسابك</small>
                                                        </label>
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                    </section>

                                    <section className="ui-sec" style={{ "--d": "70ms" }}>
                                        <FileUpload
                                            name="shareImage"
                                            customUpload
                                            uploadHandler={this.uploadShareImage}
                                            auto
                                            disabled={uploading}
                                            multiple={false}
                                            accept="image/*"
                                            maxFileSize={20000000}
                                            chooseLabel={uploading ? "جاري الرفع..." : "إختيار صورة المشاركة"}
                                            uploadLabel="رفع الصورة"
                                            cancelLabel="إلغاء"
                                            // the chooser rides the section's own heading row
                                            headerTemplate={(o) => (
                                                <div className="ui-sec-head">
                                                    <span className="n">٢</span>
                                                    <span className="t">
                                                        صورة المشاركة
                                                        <small>اختياري — أفضل مقاس 1200×630</small>
                                                    </span>
                                                    <span className="act">{o.chooseButton}</span>
                                                </div>
                                            )}
                                            emptyTemplate={<p className="p-m-0">إسحب صورة المشاركة هنا ليبدأ التحميل</p>}
                                        />
                                        {uploading ? (
                                            <div className="upload-progress-row">
                                                <ProgressSpinner style={{ width: "20px", height: "20px" }} strokeWidth="6" />
                                                <span>جاري رفع الصورة، من فضلك انتظر...</span>
                                            </div>
                                        ) : null}
                                        {ogImageUrl ? (
                                            <div className="uploaded-file-row">
                                                <img className="course-thumb-preview" src={ogImageUrl} alt="share" />
                                                <Button
                                                    icon="pi pi-times"
                                                    className="p-button-rounded p-button-text p-button-danger"
                                                    onClick={() => this.setState({ ogImageUrl: '' })}
                                                />
                                            </div>
                                        ) : image ? (
                                            <div className="ui-waiting">
                                                هيتم استخدام صورة حسابك الحالية لحد ما ترفع صورة تانية هنا.
                                            </div>
                                        ) : null}
                                    </section>

                                    {/* The whole point of the page, shown rather
                                        than described: what the link turns into. */}
                                    <section className="ui-sec" style={{ "--d": "140ms" }}>
                                        <h3>
                                            <span className="n">٣</span>
                                            <span className="t">
                                                المعاينة
                                                <small>كده تقريباً هيبان الرابط لما يتبعت</small>
                                            </span>
                                        </h3>

                                        <div className="ui-share">
                                            <div className="shot">
                                                {shownImage ? (
                                                    <img src={shownImage} alt="" />
                                                ) : (
                                                    <span className="none" aria-hidden="true">
                                                        <i className="pi pi-image"></i>
                                                    </span>
                                                )}
                                            </div>
                                            <div className="tx">
                                                <span className="host">{shownHost}</span>
                                                <b>{shownTitle}</b>
                                                <p>{shownDesc}</p>
                                            </div>
                                        </div>
                                    </section>

                                </PageLoading>
                            </Card>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default ShareMeta;
